export interface IResetPassword{
    NewPassword:string,
    ConfirmPassword:string,
    Code:string,
    UserId:string,
}
export class ResetPassword implements IResetPassword{
    NewPassword:string = '';
    ConfirmPassword:string = '';
    Code:string = '';
    UserId:string = '';
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/reset-password/reset-password.ts